"use client";

import React, { useEffect, useState } from "react";
import Link from "next/link";

const FREE_TRIAL_URL = "https://console.pickcel.com/auth/register";

/** Appears after 50% scroll and hides while the checklist form is in view. No slide animation. */
export function HealthcareStickyCta() {
  const [pastThreshold, setPastThreshold] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
      const denom = scrollHeight - window.innerHeight;
      const depth = denom > 0 ? window.scrollY / denom : 0;
      setPastThreshold(depth > 0.5);
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    document.addEventListener("scroll", onScroll, { passive: true, capture: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      document.removeEventListener("scroll", onScroll, { capture: true });
    };
  }, []);

  useEffect(() => {
    const form = document.getElementById("rollout-checklist");
    if (!form || !("IntersectionObserver" in window)) return;
    const observer = new IntersectionObserver(
      entries => setFormVisible(entries[0]?.isIntersecting ?? false),
      { threshold: 0.2 }
    );
    observer.observe(form);
    return () => observer.disconnect();
  }, []);

  if (!pastThreshold || formVisible || dismissed) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t border-white/10 bg-[#12224F] shadow-[0_-12px_40px_-20px_rgba(0,0,0,0.5)]">
      <div className="mx-auto flex max-w-[1240px] flex-wrap items-center justify-between gap-4 px-5 py-3.5 md:px-10">
        <p className="text-sm font-medium text-white md:text-base">
          Ready to improve communication across your healthcare facility?
        </p>
        <div className="ml-auto flex items-center gap-3">
          <Link
            href={FREE_TRIAL_URL}
            className="inline-flex min-h-11 items-center whitespace-nowrap rounded-lg bg-primary px-5 text-sm font-semibold text-white hover:bg-primary/90"
          >
            Start Free Trial
          </Link>
          <button
            type="button"
            onClick={() => setDismissed(true)}
            className="inline-flex min-h-11 min-w-11 items-center justify-center text-2xl leading-none text-white/70"
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      </div>
    </div>
  );
}
